import { AppRoutePermissionType } from '../navigation'

export interface PermissionResult {
  list: boolean,
  create: boolean,
  save: boolean,
  delete: boolean
}

export default (permissions: AppRoutePermissionType, userPermission: string[], activeTab: string | undefined): PermissionResult => {
  let result: PermissionResult = {
    list: true,
    create: true,
    save: true,
    delete: true
  }

  Object.keys(result).forEach(key => {
    if (typeof permissions[key] === 'string' && permissions[key].length > 0) {
      if (!userPermission.includes(permissions[key])) {
        result[key] = false
      }
    }
    if (typeof permissions[key] === 'object' && permissions[key].length > 0) {
      const perm = permissions[key].find(perm => (activeTab === undefined && perm.activeTab === null) || perm.activeTab === activeTab)
      if (perm) {
        let found = true

        perm.permission.forEach(permStr => {
          if (found) {
            found = userPermission.includes(permStr)
          }
        })

        result[key] = found
      }
    }
  })

  return result
}
